import classNames from 'classnames';
import React from 'react';
import './AccentBar.scss';

const AccentBar = (props) => <div {...props} className={classNames('accent-bar', props.className)} />;

export default AccentBar;
